import { Container } from 'taltech-styleguide';
import { StepPanelProps } from './types';
import { createRootieComponent } from '../../../../components-common/_shared';
export type StepProps = {
}

export const StepPanel = ({component}:StepPanelProps) => {
  return  <Container>{createRootieComponent(component)}</Container>;
};
